// extracted by mini-css-extract-plugin
module.exports = {"licenceBox":"style-module_licenceBox__3mre7sGdbNkDPHLNlxpybz","list":"style-module_list__33aLqctONTGeJ1gdwMD0Rf"};